import React, { FC } from "react";

import { ORI_ORB_CROP_SCALE, OriAvatar } from "components/ori";

import styles from "../december-doors.module.scss";

interface OriButtonProps {
  label: string;
  onClick: () => void;
  testId: string;
}

/** The one Ori action a door offers: its label comes from the door itself. */
const OriButton: FC<OriButtonProps> = ({ label, onClick, testId }) => (
  <button
    type="button"
    className={styles["ori-button"]}
    onClick={onClick}
    data-testid={testId}
  >
    <span className={styles["ori-button-mark"]} aria-hidden>
      <OriAvatar size={22} cropScale={ORI_ORB_CROP_SCALE} />
    </span>
    {label}
  </button>
);

export default OriButton;
